import { render } from "./KategorieHinzufuegenView.vue?vue&type=template&id=22ab0308&scoped=true"
import script from "./KategorieHinzufuegenView.vue?vue&type=script&lang=js"
export * from "./KategorieHinzufuegenView.vue?vue&type=script&lang=js"

import "./KategorieHinzufuegenView.vue?vue&type=style&index=0&id=22ab0308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ab0308"]])

export default __exports__